import { render, staticRenderFns } from "./NotesLayout.vue?vue&type=template&id=de2463ec&"
import script from "./NotesLayout.vue?vue&type=script&lang=js&"
export * from "./NotesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de2463ec')) {
      api.createRecord('de2463ec', component.options)
    } else {
      api.reload('de2463ec', component.options)
    }
    module.hot.accept("./NotesLayout.vue?vue&type=template&id=de2463ec&", function () {
      api.rerender('de2463ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/NotesLayout.vue"
export default component.exports